module.exports = __webpack_public_path__ + "static/media/logo.ffafc534.png";